import { render } from "./BaseLayout2.vue?vue&type=template&id=26f1d7f0&scoped=true"
import script from "./BaseLayout2.vue?vue&type=script&lang=js"
export * from "./BaseLayout2.vue?vue&type=script&lang=js"

import "./BaseLayout2.vue?vue&type=style&index=0&id=26f1d7f0&scoped=true&lang=css"

import exportComponent from "/var/www/html/pk_wallet/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f1d7f0"]])

export default __exports__